(function ($, document) {
  $(document).ready(function () {
    let lists = $('.product-description__accordion-each');
    let activeList = null;
    lists.each(function () {
      $(this).on('click', function () {
        var clickedList = $(this).children('.custom-field--value');
        if (activeList !== null && activeList[0] !== clickedList[0]) {
          activeList.slideUp();
        }
        activeList = clickedList;
        activeList.slideToggle();
      });
    });
  });
})(jQuery, document);
